module.exports = "/_next/static/images/9558d891d2e7d053ad810c2720fe92d2-blog-1x.jpg.webp";